// extracted by mini-css-extract-plugin
export default {"modal-title":"NRvcqufowWf1M0sjbxS3","modal-content":"btgXwZrentiCDdhaACeK","table":"VPJQqosEq48RkY7Owp6G"};